"use client";

import iconArrowUp from "@/assets/images/icon-arrow-up-light-v2.svg";
import iconArrowDown from "@/assets/images/icon-arrow-down-light-v2.svg";

export function TrendOddsDesktop({ trend }) {
  if (!trend || trend === 0 || trend === "0") return null;
  const isUp = trend === "up" || trend === "increased" || trend === 1 || trend === "1";
  const isDown = trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
  if (!isUp && !isDown) return null;
  const bg = isUp ? "kbv-cs-bg-trend-up" : "kbv-cs-bg-trend-down";
  const iconSrc = isUp ? iconArrowUp : iconArrowDown;
  return (
    <span
      className={`pointer-events-none absolute -right-0.5 -top-0.5 z-10 flex h-3 w-3 items-center justify-center overflow-hidden rounded-full ${bg}`}
      aria-hidden
    >
      <img src={iconSrc} alt="" className="h-1.5 w-1.5 object-contain" />
    </span>
  );
}

export function TrendOddsMobile({ trend }) {
  if (!trend || trend === 0 || trend === "0") return null;
  const isUp = trend === "up" || trend === "increased" || trend === 1 || trend === "1";
  const isDown = trend === "down" || trend === "decreased" || trend === 2 || trend === "2";
  if (!isUp && !isDown) return null;
  const bg = isUp ? "kbv-cs-bg-trend-up" : "kbv-cs-bg-trend-down";
  const iconSrc = isUp ? iconArrowUp : iconArrowDown;
  return (
    <span
      className={`pointer-events-none z-10 inline-flex h-3 w-3 shrink-0 items-center justify-center overflow-hidden rounded-full ${bg}`}
      aria-hidden
    >
      <img src={iconSrc} alt="" className="h-1.5 w-1.5 object-contain" />
    </span>
  );
}
